/**
 * Tell if we are on localhost
 * @param env
 */
export const isLocal = (env = process.env.REACT_APP_SERVER_ENV): env is "local" => {
  return env === "local";
};
